import React, { memo, SVGProps } from 'react'

export const Search = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10.7741 18.216C12.5673 18.216 14.2137 17.5786 15.5001 16.5178L19.439 20.4566C19.5792 20.5968 19.7635 20.6678 19.9478 20.6678C20.1321 20.6678 20.3165 20.5978 20.4566 20.4566C20.7379 20.1754 20.7379 19.7194 20.4566 19.4381L16.5177 15.4992C17.5776 14.2128 18.215 12.5664 18.215 10.7731C18.215 6.67008 14.8761 3.33216 10.7731 3.33216C6.67006 3.33216 3.33118 6.67008 3.33118 10.7731C3.33118 14.8762 6.67006 18.215 10.7731 18.215L10.7741 18.216ZM10.7741 4.77216C14.0832 4.77216 16.776 7.464 16.776 10.7731C16.776 14.0822 14.0832 16.775 10.7741 16.775C7.46494 16.775 4.77214 14.0822 4.77214 10.7731C4.77214 7.464 7.46494 4.77216 10.7741 4.77216Z"
      fill="currentColor"
    />
  </svg>
))
